import React, { Component } from "react";

import { Segment } from 'semantic-ui-react'
import { injectIntl, defineMessages, formatMessage, FormattedMessage, } from "react-intl";
import Typewriter from 'typewriter-effect';

const messages = defineMessages({
})

const ReactTypingEffectDemo = (props) => {
  return (
    <Typewriter
      options={{
        strings: props.msg,
        autoStart: true,
        loop: true,
      }}
    />
  );
};

class Moto extends Component {
  render() {
    const { intl: { formatMessage } } = this.props;

    return (
      <div>
        <div style={{

          // "backgroundColor": "transparent",
          // "color": "white",

          // "fontSize": "5.8vw",
          // "textAlign": "left",
          // "lineHeight": "0.9",
          // "paddingBottom": "50px"

        }}>
          <span>
            {/* {formatMessage(messages.share)} */}
            <ReactTypingEffectDemo msg={this.props.msg} />
          </span>

        </div>

      </div>
    )
  }
}

export default injectIntl(Moto)